export class RegisterRequest {
  constructor(
    public email: string,
    public password: string,
    public firstName: string,
    public lastName: string,
    public affiliation?: string,
  ) {}
}
